module.exports = __webpack_public_path__ + "img/sec_car1.d4721d3a.jpg";